'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    DataTd: ()=>DataTd,
    DataTdExpandable: ()=>DataTdExpandable
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const index_cjs_namespaceObject = require("../Table/index.cjs");
const react_table_namespaceObject = require("@tanstack/react-table");
const Chevron_index_cjs_namespaceObject = require("../SVG/Chevron/index.cjs");
const Button_variants_cjs_namespaceObject = require("../Button/Button.variants.cjs");
const external_DataTable_variants_cjs_namespaceObject = require("./DataTable.variants.cjs");
const external_utils_index_cjs_namespaceObject = require("../../utils/index.cjs");
const styles_cjs_namespaceObject = require("../SVG/styles.cjs");
const external_DataTBody_context_cjs_namespaceObject = require("./DataTBody.context.cjs");
const DataTd = /*#__PURE__*/ (0, external_react_namespaceObject.forwardRef)(({ table, row, cell, className, ...props }, ref)=>{
    const { cell: cellClass } = (0, external_DataTable_variants_cjs_namespaceObject.mobileVariants)(cell.column.columnDef.meta?.mobile);
    const cellProps = cell.column.columnDef.meta?.cellProps || {};
    const hasMobileResponsiveColumns = (0, external_react_namespaceObject.useMemo)(()=>Boolean(table.getAllColumns().find((column)=>column.columnDef.meta?.mobile?.breakpoint)), [
        table
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(index_cjs_namespaceObject.Td, {
        className: (0, external_utils_index_cjs_namespaceObject.cn)(cellClass(), className),
        ...cellProps,
        ...props,
        ref: ref,
        children: [
            (0, react_table_namespaceObject.flexRender)(cell.column.columnDef.cell, cell.getContext()),
            hasMobileResponsiveColumns && 0 === cell.column.getIndex() && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("dl", {
                className: "block lg:hidden",
                children: row.getVisibleCells().slice(1).map((cell)=>{
                    const { describe } = (0, external_DataTable_variants_cjs_namespaceObject.mobileVariants)(cell.column.columnDef.meta?.mobile);
                    return cell.column.columnDef.meta?.mobile?.breakpoint && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_react_default().Fragment, {
                        children: [
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("dt", {
                                className: "hidden",
                                children: cell.column.columnDef.header?.toString()
                            }, `${cell.id}-mobile-dt`),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("dd", {
                                className: describe(),
                                children: (0, react_table_namespaceObject.flexRender)(cell.column.columnDef.cell, cell.getContext())
                            }, `${cell.id}-mobile-dd`)
                        ]
                    }, `${cell.id}-mobile-fragment`);
                })
            }, `${cell.id}-mobile-dl`)
        ]
    }, cell.id);
});
const DataTdExpandable = ({ getValue, row })=>{
    const { setCollapsingRow } = (0, external_DataTBody_context_cjs_namespaceObject.useDataTBodyContext)();
    const { buttonSlot } = (0, Button_variants_cjs_namespaceObject.buttonVariants)({});
    const value = getValue();
    const isExpandable = row.getCanExpand() && row.subRows.length > 0;
    const onClick = (0, external_react_namespaceObject.useCallback)(()=>{
        const isExpanded = row.getIsExpanded();
        if (!isExpanded) return row.toggleExpanded();
        setCollapsingRow(row.id);
        setTimeout(()=>{
            row.toggleExpanded();
            setCollapsingRow(null);
        }, 1000 * (0, styles_cjs_namespaceObject.getTransitionDurationLong)());
    }, [
        row,
        setCollapsingRow
    ]);
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
        className: "flex items-center",
        children: [
            Array.from({
                length: row.depth - 1
            }, (_, index)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    className: "w-9"
                }, index)),
            isExpandable && row.depth > 0 && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(jsx_runtime_namespaceObject.Fragment, {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: "relative w-7",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                            className: "absolute right-0 top-1/2 -translate-y-1/2",
                            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("button", {
                                className: (0, external_utils_index_cjs_namespaceObject.cn)(buttonSlot(), 'bg-transparent p-2'),
                                onClick: onClick,
                                children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Chevron_index_cjs_namespaceObject.Chevron, {
                                    className: "text-primary-8 p-0",
                                    isOpen: row.getIsExpanded()
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        className: "w-2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, external_react_namespaceObject.isValidElement)(value) ? value : String(value)
        ]
    });
};
exports.DataTd = __webpack_exports__.DataTd;
exports.DataTdExpandable = __webpack_exports__.DataTdExpandable;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "DataTd",
    "DataTdExpandable"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
